import React from "react";
import { GetFusionAuthAccessToken } from "../../Services/UserSessionManager";

export const IdeasList = () => {
  const externalURL = process.env.REACT_APP_STEMS_IDEAPORTAL_URL;

  const fusionAuthToken = GetFusionAuthAccessToken();
  const urlWithToken = `${externalURL}?GetFusionAuthAccessToken=${encodeURIComponent(
    fusionAuthToken
  )}`;

  return (
    <div
      className="row"
      style={{
        minHeight: "calc(100vh - 2rem - 56px)",
        marginRight: 0,
        marginLeft: 0,
        alignItems: "center",
      }}
    >
      <iframe
        title="ExternalContent"
        width="1140"
        height="555"
        src={urlWithToken}
        frameBorder="0"
        allowFullScreen
        style={{
          minHeight: "calc(100vh - 4rem - 56px)",
        }}
      ></iframe>
    </div>
  );
};
